import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';
import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { IPagination } from '../../../../../shared/crud/list/pagination.interface';
import { ISelectOption } from '../../../../../shared/form/element/base-select/select-option.interface';
import { ErrorCodes } from '../../../../../shared/enum/api-errors';

@Component({
  selector: 'admin-payment-list',
  templateUrl: './list.component.html',
  styleUrls: [ './list.component.scss' ],
})
export class AdminPaymentListComponent extends AbstractListComponent implements OnInit {

  public selectedListType: string;
  public dateFilterModel: any;
  private dateFilterYear: number;
  private dateFilterMonth: number;
  private listTypesObject = {
    upcoming: 'Upcoming',
    pending: 'Pending',
    approved: 'Approved',
    free: 'Free'
  };

  public listTypes: ISelectOption[] = Object
    .keys(this.listTypesObject)
    .map((type: string) => {
      return {
        value: type,
        label: this.listTypesObject[type]
      };
    });

  constructor(
    httpClient: HttpClient,
    toastrService: ToastrService,
    router: Router,
    route: ActivatedRoute,
    private breadcrumbBuilder: BreadcrumbBuilder
  ) {
    super(httpClient, toastrService, router, route);
  }

  ngOnInit() {
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Payments',
      url: '/admin/payment',
    });

    const currentDate = new Date();
    this.dateFilterModel = currentDate;
    this.dateFilterYear = currentDate.getFullYear();
    this.dateFilterMonth = currentDate.getMonth() + 1;
    this.onListTypeChange('upcoming');
  }

  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('month');
  }

  onDateFilterChange(value: Date) {
    this.dateFilterYear = value.getFullYear();
    this.dateFilterMonth = value.getMonth() + 1;
    this.parameters.conditions.listType = this.selectedListType;
    this.parameters.conditions.dateFilterYear = this.dateFilterYear;
    this.parameters.conditions.dateFilterMonth = this.dateFilterMonth;

    this.fetchRemoteSource().subscribe();
  }

  onListTypeChange(listType: string) {
    this.selectedListType = listType;
    this.parameters.conditions.listType = this.selectedListType;
    this.parameters.conditions.dateFilterYear = this.dateFilterYear;
    this.parameters.conditions.dateFilterMonth = this.dateFilterMonth;

    this.fetchRemoteSource().subscribe();
  }

  buildUrl() {
    let url = this.getResourceUrl();
    if (this.urlBuilder) {
      url = this.urlBuilder.buildUrl(url);
    }

    return url;
  }

  fetchRemoteSource(): Observable<any> {
    return this.httpClient.get<any>(this.buildUrl(), { params: this.parameters.toStringParams() }).pipe(
      map((response: any) => {
        this.pagination = <IPagination>response;
        return response;
      }, (error: HttpErrorResponse) => {
        this.toastrService.error(error.error ? (error.error.message || ErrorCodes[error.error.code] || 'Something went wrong...') : 'Error');
        return error;
      }));
  }

  getResourceUrl(): string {
    return '/admin/payment';
  }
}
